import GroupSetsStore, {
  initState as groupSetsInitState,
} from './groupSets.reducer';

import CostTablesStore, {
  initState as costTablesInitState,
} from './costTables.reducer';

import { StoreState } from '@Types';
import { combineReducers } from 'redux';
import { moduleNamespace } from '@Store/config.store';

export const initialState: StoreState = {
  GroupSetsStore: groupSetsInitState,
  CostTablesStore: costTablesInitState,
};

export default combineReducers({
  GroupSetsStore,
  CostTablesStore,
});

export const reducerKey = moduleNamespace;
